import { render } from "./Winner.vue?vue&type=template&id=57304a09"
import script from "./Winner.vue?vue&type=script&lang=js"
export * from "./Winner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__